// Formattazione date unificata — configurabile a runtime dal LocaleContext.
// Le preferenze effettive (fuso orario + formati) sono impostate da `setLocale()`
// al login e ad ogni salvataggio. Fallback: Europe/Rome, gg-mm-aa, 24h.

const DEFAULT_SETTINGS = {
  timezone: "Europe/Rome",
  date_format: "dd/MM/yyyy",  // "dd/MM/yyyy" | "yyyy-MM-dd"
  time_format: "24h",          // "24h" | "12h"
  week_start: "monday",        // "monday" | "sunday"
};

let _settings = { ...DEFAULT_SETTINGS };
const _listeners = new Set();

export function setLocale(partial) {
  _settings = { ..._settings, ...(partial || {}) };
  _listeners.forEach((fn) => { try { fn(_settings); } catch { /* noop */ } });
}
export function getLocale() { return { ..._settings }; }
export function subscribeLocale(fn) { _listeners.add(fn); return () => _listeners.delete(fn); }

const toDate = (v) => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

// Ritorna un oggetto con day/month/year/hour/minute/second già nel TZ configurato.
const _parts = (d) => new Intl.DateTimeFormat("en-GB", {
  timeZone: _settings.timezone,
  day: "2-digit", month: "2-digit", year: "numeric",
  hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
}).formatToParts(d).reduce((a, x) => { a[x.type] = x.value; return a; }, {});

export const fmtDate = (v, fallback = "—") => {
  const d = toDate(v);
  if (!d) return fallback;
  const p = _parts(d);
  const yy = p.year.slice(-2);
  if (_settings.date_format === "yyyy-MM-dd") {
    return `${p.year}-${p.month}-${p.day}`;
  }
  return `${p.day}-${p.month}-${yy}`;
};

export const fmtDateLong = (v, fallback = "—") => {
  const d = toDate(v);
  if (!d) return fallback;
  const p = _parts(d);
  if (_settings.date_format === "yyyy-MM-dd") {
    return `${p.year}-${p.month}-${p.day}`;
  }
  return `${p.day}/${p.month}/${p.year}`;
};

const _fmtTimeParts = (p) => {
  if (_settings.time_format === "12h") {
    let h = Number(p.hour);
    const am = h < 12;
    h = h % 12 || 12;
    return `${String(h).padStart(2, "0")}:${p.minute} ${am ? "AM" : "PM"}`;
  }
  return `${p.hour}:${p.minute}`;
};

export const fmtTime = (v, fallback = "—") => {
  const d = toDate(v);
  if (!d) return fallback;
  return _fmtTimeParts(_parts(d));
};

export const fmtDateTime = (v, fallback = "—") => {
  const d = toDate(v);
  if (!d) return fallback;
  const p = _parts(d);
  const datePart = _settings.date_format === "yyyy-MM-dd"
    ? `${p.year}-${p.month}-${p.day}`
    : `${p.day}-${p.month}-${p.year.slice(-2)}`;
  const timePart = _fmtTimeParts(p);
  return `${datePart} ${timePart}`;
};
